import React from "react";

const SearchButton = ({ onClick, loading = false, disabled = false, label = "Axtar" }) => (
  <button
    onClick={onClick}
    disabled={loading || disabled}
    style={{
      background: loading ? "var(--color-primary-dark)" : "var(--color-primary)",
      color: "#fff",
      border: "none",
      borderRadius: 8,
      padding: "6px 16px",
      fontWeight: 600,
      fontSize: 14,
      cursor: loading || disabled ? "not-allowed" : "pointer",
      display: "flex",
      alignItems: "center",
      gap: 6,
      opacity: loading ? 0.8 : 1,
      transition: "opacity 0.2s, background 0.2s",
      flexShrink: 0,
    }}
  >
    <i className={`bi bi-search${loading ? " spin" : ""}`} />
    {loading
      ? <span className="dot-loader"><span>.</span><span>.</span><span>.</span></span>
      : label
    }
  </button>
);

export default SearchButton;
